import script from "./Tooling.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tooling.vue?vue&type=script&setup=true&lang=ts"

import "./Tooling.vue?vue&type=style&index=0&id=5bac09f9&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bac09f9"]])

export default __exports__